import {AxiosProgressEvent} from 'axios';

import {PostAppointmentAttachment} from 'domain/usecases';
import {RemotePostAppointmentAttachment} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostAppointmentAttachment = (
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): PostAppointmentAttachment =>
	new RemotePostAppointmentAttachment(
		makeBFFApiUrl(BookedFlowEndPoints.appointmentAttachments),
		makeAuthorizeHttpClientDecorator(),
		onUploadProgress,
	);
